/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const stop_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeWidth={1.5}
      d="M19.778 4.222A10.966 10.966 0 0 0 12 1C5.925 1 1 5.925 1 12c0 3.038 1.231 5.788 3.222 7.778M19.778 4.222A10.966 10.966 0 0 1 23 12c0 6.075-4.925 11-11 11a10.966 10.966 0 0 1-7.778-3.222M19.778 4.222 4.222 19.778"
    />
  </svg>
)
export default stop_medium
